/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.panel()
    export class GroupsDialog extends NoboxEntityDialog<GroupsRow, any> {
        protected getFormKey() { return GroupsForm.formKey; }
        protected getIdProperty() { return GroupsRow.idProperty; }
        protected getLocalTextPrefix() { return GroupsRow.localTextPrefix; }
        protected getNameProperty() { return GroupsRow.nameProperty; }
        protected getService() { return GroupsService.baseUrl; }
        protected getDeletePermission() { return GroupsRow.deletePermission; }
        protected getInsertPermission() { return GroupsRow.insertPermission; }
        protected getUpdatePermission() { return GroupsRow.updatePermission; }

        protected form = new GroupsForm(this.idPrefix);
        private tasksKanban: TaskKanbanDialog;

        private groupLogPropertyGrid: Serenity.PropertyGrid;
        private groupLogForm: GroupLogsForm;
        private groupLogValidator: JQueryValidation.Validator;


        private groupNotePropertyGrid: Serenity.PropertyGrid;
        private groupNoteForm: GroupNotesForm;
        private groupNoteValidator: JQueryValidation.Validator;

        private userLogin;
        private jmlNote: number;
        private jmlLog: number;
        constructor(container?: JQuery) {
            super(container);
            var $this = this;
            this.tasksKanban = new nobox.TaskKanbanDialog(this.byId('kontakkanban'), this.byId('kontakcalendar'), true);

            this.tasksKanban.dialogOpen();
            $(`a[href='#${this.byId('TabTask').attr("id")}']`).on("click", () => {
                this.tasksKanban.refreshSize();
            });
            this.groupLogPropertyGrid = new Serenity.PropertyGrid(this.byId("GroupLogPropertyGrid"), {
                idPrefix: this.idPrefix + "_GroupLog_",
                items: Q.getForm(GroupLogsForm.formKey),
                useCategories: true
            });

            this.groupNotePropertyGrid = new Serenity.PropertyGrid(this.byId("GroupNotePropertyGrid"), {
                idPrefix: this.idPrefix + "_GroupNote_",
                items: Q.getForm(GroupNotesForm.formKey),
                useCategories: true
            });


            // this is just a helper to access editors if needed
            this.groupLogForm = new GroupLogsForm(this.groupLogPropertyGrid.get_idPrefix());
            this.groupNoteForm = new GroupNotesForm(this.groupNotePropertyGrid.get_idPrefix());

            // initialize validator for customer form
            this.groupLogValidator = this.byId("GroupLogForm").validate(Q.validateOptions({}));
            this.groupNoteValidator = this.byId("GroupNoteForm").validate(Q.validateOptions({}));
            if ($(document).width() < 576) {
                this.form.In.toggle(false);
                this.form.Up.toggle(false);
            }
            this.groupLogForm.Logs.element.parents(".categories").addClass("custom-note");
            this.groupLogForm.Logs.element.parents(".categories").append(`<div class="nk-reply-meta mx-1 toggle-log" style="cursor: pointer;"><div class="nk-reply-meta-info"><strong><i class="fa fa-caret-down pr-1"> </i>List Log</strong></div></div>`);
            this.groupLogForm.Logs.element.parents(".categories").append(`<div class="nk-block block-res-msg log-container"></div>`);
            this.groupNoteForm.Notes.element.parents(".categories").append(`<div class="field custom-note"><input type="text" data-act="add" placeholder="Type note here.." class="input-note" name="note" style="flex:1 1 auto;"><a class="inplace-button button-kirim-catatan" style="width:26px !important;" title="Add Note"><b><i class="fa fa-paper-plane text-primary"></i></b></a></div>`);
            this.groupNoteForm.Notes.element.parents(".categories").append(`<div class="nk-reply-meta mx-1 toggle-note" style="cursor: pointer;"><div class="nk-reply-meta-info"><strong><i class="fa fa-caret-down pr-1"> </i>List Note</strong></div></div>`);
            this.groupNoteForm.Notes.element.parents(".categories").append(`<div class="nk-block block-res-msg note-container"></div>`);
            this.groupLogForm.Logs.element.parents(".categories").find(".toggle-log").on("click", function () {
                if ($this.groupLogForm.Logs.element.parents(".categories").find(".log-container").is(":visible")) {
                    $(this).find("strong i").remove();
                    $this.groupLogForm.Logs.element.parents(".categories").find(".log-container").slideUp(500)
                    $(this).find("strong").prepend(`<i class="fa fa-caret-up pr-1"> </i>`)
                } else {
                    $(this).find("strong i").remove();
                    $this.groupLogForm.Logs.element.parents(".categories").find(".log-container").slideDown(500)
                    $(this).find("strong").prepend(`<i class="fa fa-caret-down pr-1"> </i>`)
                }
            })

            $this.groupNoteForm.Notes.element.parents(".categories").find(".toggle-note").on("click", function () {
                if ($this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").is(":visible")) {
                    $(this).find("strong i").remove();
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").slideUp(500)
                    $(this).find("strong").prepend(`<i class="fa fa-caret-up pr-1"> </i>`)
                } else {
                    $(this).find("strong i").remove();
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").slideDown(500)
                    $(this).find("strong").prepend(`<i class="fa fa-caret-down pr-1"> </i>`)
                }
            })
            $this.groupNoteForm.Notes.element.parents(".categories").find(".button-kirim-catatan").on("click", function () {
                if ($this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-act") == "add") {
                    $this.addNote();
                } else {
                    $this.updateNote();
                }
            });
            $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().keyup(function (e) {
                if (e.keyCode === 13) {
                    if ($(this).attr("data-act") == "add") {
                        $this.addNote();
                    } else {
                        $this.updateNote();
                    }
                }
            })

            var initFile = false;
            this.form.Image.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
        }
        loadEntity(entity: GroupsRow) {
            super.loadEntity(entity);

            Serenity.TabsExtensions.setDisabled(this.tabs, 'Log', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Task', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Note', this.isNewOrDeleted());
            if (this.isNewOrDeleted()) {
                //this.byId('LogsGrid').hide();
                //this.byId('tasksKanban').hide();
                this.form.In.element.closest('.category').toggle(false);
            }
            //Q.reloadLookup("Nobox.ListsLookup");
            if (this.isEditMode()) {
                this.tasksKanban.groupId = entity.Id;
                this.tasksKanban.onBoardRender = () => {
                    if (this.byId('TabNote').is(":visible")) {
                        this.byId('TabTask').hide();
                    }
                    if (this.byId("TabLog").is(":visible")) {
                        this.byId('TabTask').hide();
                    }
                    if (this.byId("TabGroup").is(":visible")) {
                        this.byId('TabTask').hide();
                    }
                }
            }
        }
        addNote() {
            var pesan = Q.trim(this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val());
            var $this = this;
            if (pesan == "" || pesan == null) {

            } else {
                Q.serviceCall({
                    blockUI: false,
                    url: "/Services/Nobox/Lognotes/Create",
                    request: {
                        Entity: {
                            NmMenu: "Group",
                            IdModul: this.get_entityId(),
                            Activity: "Added a note",
                            Type: "note",
                            Comment: pesan
                        },
                    },
                    onSuccess: (response) => {
                        $this.getNotes(this.userLogin, false);
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val("");
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-act", "add")
                    }
                });
            }
        }

        updateNote() {
            var pesan = Q.trim(this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val());
            var $this = this;
            if (pesan == "" || pesan == null) {

            } else {
                Q.serviceCall({
                    blockUI: false,
                    url: "/Services/Nobox/Lognotes/Update",
                    request: {
                        EntityId: $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-id"),
                        Entity: {
                            NmMenu: "Group",
                            IdModul: this.get_entityId(),
                            Activity: "Updated a note",
                            Type: "note",
                            Comment: pesan
                        },
                    },
                    onSuccess: (response) => {
                        $this.getNotes(this.userLogin, false);
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val("");
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-act", "add")
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-id", "");
                    }
                });
            }
        }

        editNote(id) {
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").val($(".data-text" + id).text());
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").attr("data-act", "edit")
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").attr("data-id", id)
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").focus();
        }
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);

            if (parts[1] == undefined) {
                if (name == "formatdate") {
                    return "DD-MM-YYYY";
                } else if (name == "formattime") {
                    return "HH:mm";
                } else if (name == "timezone") {
                    return "Asia/Jakarta";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }
        regexDateTime(format) {
            return format.replace(new RegExp("%2C", 'g'), ",").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%20", 'g'), " ").replace(new RegExp("%3A", 'g'), ":");
        }
        getLogs(UserSource, isMore) {
            var $this = this;
            var arrLog = [];
            var kemarin = moment().utc().add(-1, 'd').format("DD-MM-YYYY");
            this.jmlLog = isMore == false ? 0 : this.jmlLog;
            Q.serviceCall({
                blockUI: false,
                url: "/Services/Nobox/Lognotes/List",
                request: {
                    EqualityFilter: { NmMenu: "Group", IdModul: $this.get_entityId(), Type: "log" },
                    IncludeColumns: ["Type", "Tgl", "UserId", "Comment", "Activity", "userImg", "userlog"],
                    ColumnSelection: 1,
                    Skip: this.jmlLog,
                    Take: 5,
                    Sort: ["Tgl DESC"]
                },
                onSuccess: (resLog: Serenity.ListResponse<nobox.LognotesRow>) => {
                    arrLog = resLog.Entities;
                    this.jmlLog = this.jmlLog == undefined ? 0 + arrLog.length : this.jmlLog + arrLog.length;
                    if (arrLog.length) {
                        arrLog.forEach(function (e, eindx) {
                            if (eindx == 0 && isMore == false) {
                                $this.groupLogForm.Logs.element.parents(".categories").find(".log-container").html("");
                            }
                            var UserImg = ""
                            if (Q.isEmptyOrNull(e.userImg)) {
                                UserImg = `<div class="user-lkavatar">
                                                <span>${e.userlog.charAt(0).toUpperCase()}</span>
                                            </div>`
                            } else {
                                UserImg = `<div class="user-lkavatar">
                                                <img style="width:inherit;" src="/upload/${e.userImg}">
                                            </div>`
                            }
                            var strTgl = "";
                            if (moment(e.Tgl).utc().format("DD-MM-YYYY") == moment().utc().format("DD-MM-YYYY")) {
                                strTgl = "Today " + moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formattime")));
                            } else if (moment(e.Tgl).utc().format("DD-MM-YYYY") == kemarin) {
                                strTgl = "Yesterday " + moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formattime")));
                            } else if (moment(e.Tgl).utc().format("YYYY") == moment().utc().format("YYYY")) {
                                strTgl = moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formatdate")) + ", " + $this.regexDateTime($this.getCookie("formattime")));
                            } else {
                                strTgl = moment.utc(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formatdate")) + ", " + $this.regexDateTime($this.getCookie("formattime")));
                            }
                            var tmpMsg = $("");
                            var alasanStr = ``
                            if (Q.isEmptyOrNull(e.Comment)) {
                                alasanStr = `<span class="sub-text"><span class="fw-bold pr-1">Ket : </span>${e.Comment}</span>`
                            }
                            tmpMsg = $(`
                        <div class="user-lkcard bg-lighter p-2 m-1">
                            ${UserImg}
                            <div class="user-info">
                                <span class="lead-text">${e.userlog.toString()}<span class="text-muted small p-1"> - ${strTgl}</span><span class="text-muted small">(${e.Activity})</span></span>
                                ${e.Comment}
                                ${alasanStr}
                            </div>
                        </div>`);
                            $this.groupLogForm.Logs.element.parents(".categories").find(".log-container").append(tmpMsg);
                        })

                        if (this.jmlNote % 5 == 0) {
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".log-container").append(`<div class="center inplace-button text-blue pl-1 pr-1 more-log" style="margin: auto;width: fit-content;font-weight: 500;">Show more</div>`)
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".more-log").on("click", function () {
                                $this.getNotes(UserSource, true);
                                $(".more-log").remove();
                            });
                        }
                        if (arrLog.length == 0) {
                            $this.groupLogForm.Logs.element.parents(".categories").find(".log-container").html("");
                            $this.groupLogForm.Logs.element.parents(".categories").find(".log-container").append(`
                        <div class="user-lkcard bg-lighter p-2 m-1 justify-content-center log-content">
                            <div class="user-info">
                                <span class="text-muted">No log yet.</span>
                            </div>
                        </div>`);
                        }
                    }
                    else {
                        $this.groupLogForm.Logs.element.parents(".categories").find(".log-container").append(`<div class="center" style="margin: auto;width: fit-content;">No more logs...</div>`)
                    }
                    $(".more-log").on("click", function () {
                        $this.getLogs(UserSource, true);
                        $(".more-log").remove();
                    });
                }
            });
        }
        getNotes(UserSource, isMore) {
            var $this = this;
            var arrNote = [];
            var kemarin = moment().utc().add(-1, 'd').format("DD-MM-YYYY");
            this.jmlNote = isMore == false ? 0 : this.jmlNote;
            Q.serviceCall({
                blockUI: false,
                url: "/Services/Nobox/Lognotes/List",
                request: {
                    EqualityFilter: { NmMenu: "Group", IdModul: $this.get_entityId(), Type: "note" },
                    IncludeColumns: ["Type", "Tgl", "UserId", "Comment", "Activity", "userImg", "userlog"],
                    ColumnSelection: 1,
                    Skip: this.jmlNote,
                    Take: 5,
                    Sort: ["Tgl DESC"]
                },
                onSuccess: (resLog: Serenity.ListResponse<nobox.LognotesRow>) => {
                    arrNote = resLog.Entities;
                    this.jmlNote = this.jmlNote == undefined ? 0 + arrNote.length : this.jmlNote + arrNote.length;
                    if (arrNote.length) {
                        arrNote.forEach(function (e, eindx) {
                            if (eindx == 0 && isMore == false) {
                                $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").html("");
                            }
                            var UserImg = ""
                            if (Q.isEmptyOrNull(e.userImg)) {
                                UserImg = `<div class="user-lkavatar">
                                                <span>${e.userlog.charAt(0).toUpperCase()}</span>
                                            </div>`
                            } else {
                                UserImg = `<div class="user-lkavatar">
                                                <img style="width:inherit;" src="/upload/${e.userImg}">
                                            </div>`
                            }
                            var strTgl = "";
                            if (moment(e.Tgl).utc().format("DD-MM-YYYY") == moment().utc().format("DD-MM-YYYY")) {
                                strTgl = "Today " + moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formattime")));
                            } else if (moment(e.Tgl).utc().format("DD-MM-YYYY") == kemarin) {
                                strTgl = "Yesterday " + moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formattime")));
                            } else if (moment(e.Tgl).utc().format("YYYY") == moment().utc().format("YYYY")) {
                                strTgl = moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formatdate")) + ", " + $this.regexDateTime($this.getCookie("formattime")));
                            } else {
                                strTgl = moment.utc(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formatdate")) + ", " + $this.regexDateTime($this.getCookie("formattime")));
                            }
                            var tmpMsg = $("");
                            var strEdit = e.UserId == UserSource.UserId ? ` <span class="sub-text pl-1"><i class="fas fa-edit text-primary edit-note" data-note-id="${e.Id}" style="cursor:pointer;" title="Edit this note"></i></span>` : '';
                            var strDelete = e.UserId == UserSource.UserId ? ` <span class="sub-text pl-1"><i class="fas fa-trash text-danger delete-note" data-note-id="${e.Id}" style="cursor:pointer;" title="Delete this note"></i></span>` : '';
                            tmpMsg = $(`
                        <div class="user-lkcard bg-lighter p-2 m-1">
                            ${UserImg}
                            <div class="user-info">
                                <span class="lead-text lead-text${e.Id}">${e.userlog.toString()}<span class="text-muted small p-1"> - ${strTgl}</span><span class="text-muted small">(${e.Activity})</span>${strEdit + strDelete}</span>
                                <span class="sub-text data-text${e.Id}">${e.Comment}</span>
                            </div>
                        </div>`);
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(tmpMsg);
                        });
                        if (this.jmlNote % 5 == 0) {
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(`<div class="center inplace-button text-blue pl-1 pr-1 more-note" style="margin: auto;width: fit-content;font-weight: 500;">Show more</div>`)
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".more-note").on("click", function () {
                                $this.getNotes(UserSource, true);
                                $(".more-note").remove();
                            });
                        }
                        if (arrNote.length == 0 && isMore == true) {
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").html("");
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(`
                    <div class="user-lkcard bg-lighter p-2 m-1 justify-content-center note-content">
                        <div class="user-info">
                            <span class="text-muted">No note yet.</span>
                        </div>
                    </div>`);
                        }
                    }
                    else {
                        if (isMore == false && this.jmlNote < 1) {
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").html("");
                        }
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(`<div class="center" style="margin: auto;width: fit-content;">No more notes...</div>`)
                    }
                    $(".edit-note").on("click", function () {
                        $this.editNote($(this).attr("data-note-id"));
                    });
                    $(".delete-note").on("click", function () {
                        var idDel = $(this).attr("data-note-id");
                        Q.confirm("Delete note?", function () {
                            Q.serviceCall({
                                blockUI: false,
                                url: "/Services/Nobox/Lognotes/Delete",
                                request: {
                                    EntityId: idDel
                                },
                                onSuccess: (hasil) => {
                                    $this.getNotes(UserSource, false);
                                }
                            })
                        })
                    });
                }
            });
        }

        protected updateInterface() {
            super.updateInterface();
            var $this = this;

            Q.serviceCall({
                blockUI: false,
                url: "/Services/Administration/User/List",
                request: {
                    EqualityFilter: { Username: Q.Authorization.username },
                    IncludeColumns: ["DisplayName", "UserImage"],
                    ColumnSelection: 1,
                    Take: 1
                },
                onSuccess: (res: Serenity.ListResponse<Administration.UserRow>) => {
                    this.userLogin = res.Entities[0];
                    if ($this.isEditMode()) {
                        if (this.userLogin.UserId == $this.get_entity().OwnerId) {
                            //Serenity.EditorUtils.setReadOnly($this.form.OwnerId, false);
                            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), false);
                            Serenity.EditorUtils.setReadOnly($this.form.In, true);
                            Serenity.EditorUtils.setReadOnly($this.form.InBy, true);
                            Serenity.EditorUtils.setReadOnly($this.form.Up, true);
                            Serenity.EditorUtils.setReadOnly($this.form.UpBy, true);
                        } else {
                            //Serenity.EditorUtils.setReadOnly($this.form.OwnerId, true);
                            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                        }
                    } else {
                        Serenity.EditorUtils.setValue($this.form.OwnerId, this.userLogin.UserId);
                    }

                    //Log Notes
                    if (this.isEditMode()) {
                        this.element.find(".btn-vcard").toggle(true);
                        this.getLogs(this.userLogin, false);
                        this.getNotes(this.userLogin, false);
                    }
                    $(".edit-note").on("click", function () {
                        $this.editNote($(this).attr("data-note-id"));
                    });
                }
            });
        }
        onDialogClose() {
            this.tasksKanban.dialogClose();
        }
        dialogClose() {
            this.tasksKanban.dialogClose();
            super.dialogClose();
        }


        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
                        <ul>
                            <li><a href="#~_TabGroup"><span>Info</span></a></li>
                            <li><a href="#~_TabLog"><span>Logs</span></a></li>
                            <li><a href="#~_TabTask"><span>Tasks</span></a></li>
                            <li><a href="#~_TabNote"><span>Notes</span></a></li>
                        </ul>
                        <div id="~_TabGroup" class="tab-pane s-TabCampaign">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                         <div id="~_TabLog" class="tab-pane s-TabLog">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_GroupLogForm" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_GroupLogPropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabTask" class="tab-pane s-TabTask" style="display: none;">
                            <div id="~_kontakkanban"></div>
                            <div id="~_kontakcalendar" class="pt-2"style="display:none;"></div>
                            <div class="s-Form d-none">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabNote" class="tab-pane s-TabNote">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_GroupNoteForm" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_GroupNotePropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>`;
        }

    }
}